module.exports = __webpack_public_path__ + "img/abundant4.98e2152a.png";